import { apiGet, apiPut } from "./client";
import type { FieldValue } from "../types";

export function getFieldValueCurrent(
  fieldValueId: number,
): Promise<FieldValue> {
  return apiGet<FieldValue>(
    `/input-modeldata/value/${fieldValueId}/current`,
  );
}

export interface UpdateFieldValuePayload {
  id: number;
  value: unknown;
}

export function updateFieldValue(
  id: number,
  value: unknown,
): Promise<FieldValue> {
  return apiPut<FieldValue>(`/input-modeldata/value/${id}`, { value });
}

export interface TimeSerie {
  id: number;
  unit: string;
  timing_id: number;
  elems: TimeSerieElem[];
}

export interface TimeSerieElem {
  id: number;
  date: string;
  value: number;
}

export function getTimeSerie(id: number): Promise<TimeSerie> {
  return apiGet<TimeSerie>(`/input-modeldata/value/timeserie/${id}`);
}

export function updateTimeSerie(
  id: number,
  unit: string,
  timingId: number,
): Promise<TimeSerie> {
  return apiPut<TimeSerie>(`/input-modeldata/value/timeserie/${id}`, {
    unit,
    timing_id: timingId,
  });
}

export function updateTimeSerieElems(
  id: number,
  elems: unknown,
): Promise<void> {
  return apiPut<void>(
    `/input-modeldata/value/timeserie/${id}/elems`,
    elems,
  );
}
